import { CircularProgress, Tooltip } from "@mui/material";
import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import { Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

type Props = {
  isSynching: boolean;
  updatedAt?: Date | null;
};

const SyncIndicatorContainer = styled(Box)`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.text.colors.primary};
  cursor: default;
`;

export const SyncIndicator = (props: Props) => {
  const { isSynching, updatedAt } = props;

  const updatedAtDate = updatedAt
    ? new Date(updatedAt).toLocaleTimeString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : null;

  return (
    <SyncIndicatorContainer>
      {isSynching ? (
        <CircularProgress size={20} />
      ) : (
        <Tooltip
          title={updatedAtDate ? `Last updated at ${updatedAtDate}` : ""}
        >
          <CloudDoneOutlinedIcon />
        </Tooltip>
      )}
    </SyncIndicatorContainer>
  );
};
